import { GQLOrderFragment } from '@theprintbar/graphql';

export function getOrderItemQuantity(orderItem: { sizes?: { quantity: number }[] | null }) {
	return orderItem.sizes?.reduce((acc, size) => acc + size.quantity, 0) || 0;
}

export function getOrderQuantity(order: GQLOrderFragment) {
	return order.items?.reduce((acc, item) => acc + getOrderItemQuantity(item), 0) || 0;
}
